import * as TYPES from './care-team-actiontypes';

const initialState = {
  members: [],
};

const careTeamReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.CARE_TEAM_LOADED_SUCCESS:
      newState = { ...action.state };
      break;
    case TYPES.CARE_TEAM_LOADED_FAILURE:
      newState = { members: initialState.members };
      break;
    default:
      newState = state;
  }
  return newState;
};

export default careTeamReducer;
